import React          from 'react';
import halfEgg        from '../images/halfEgg.png';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    halfEggs: {
      position:           'absolute',
      backgroundPosition: 'center',
      backgroundImage:    `url(${ halfEgg })`,
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
    }
}))

type DragableEggProps = {
    drag:              boolean;
    wideScreen:        boolean;
    disable:           boolean;
    dontShow:          boolean;
    putEggBackInBox:   boolean;
    showFinalValue:    boolean;
    ind:               number;
    index:             number;
    handleMouseDown:   (e: React.MouseEvent, ind: number) => void;
    handleTouchStart:  (e: React.TouchEvent, ind: number) => void;
    handleRejection:   () => void;
}



const DragableEgg: React.FC<DragableEggProps> = ({ 
    drag, 
    wideScreen,
    disable,
    dontShow,
    putEggBackInBox,
    showFinalValue,
    ind,
    index,
    handleMouseDown,
    handleTouchStart,
    handleRejection
}) => {

  const classes = useStyles();

  const [opacity, setOpacity] = React.useState(1)

/* 
  console.log('showFinalValue     :     ',showFinalValue)
  console.log('putEggBackInBox    :     ',putEggBackInBox) */

  React.useEffect(() => {
   if (showFinalValue) {
      setOpacity(1)
      return
   }
   if (!drag) {
      if (dontShow) {
         setOpacity(0)
      }
      return
   }
   if (putEggBackInBox) { 
      setOpacity(1) 
   } 
  },[putEggBackInBox, drag, dontShow, showFinalValue])

  const halfEggsPositions = React.useMemo(() => {
     return(
        wideScreen 
        ? 
        [[18, 18, 64, 64, 112, 112, 158, 158, 203, 203], [29, 2, 29, 2, 29, 2, 29, 2, 29, 2]]
        :
        [[28, 28, 48, 48, 69, 69, 90, 90, 110, 110], [12, 0, 12, 0, 12, 0, 12, 0, 12, 0]]
     )
  },[wideScreen])


  const mouseDown = (e: React.MouseEvent, index: number) => {
     if (!drag || disable || opacity === 0) {
        handleRejection()
        return
     } 
     setOpacity(0)
     handleMouseDown(e, (index * 100) - ind)
     
  }
  

  const touchStart = (e: React.TouchEvent, index: number) => {
   if (!drag || disable || opacity === 0) {
      handleRejection()
      return
   }  
   setOpacity(0)
   handleTouchStart(e, (index * 100) - ind)
}

  return (
       <div
         className     = { classes.halfEggs }
         onMouseDown   = { e => { mouseDown(e, index) }}
         onTouchStart  = { e => { touchStart(e, index) }}
         style         = {{ 
            width:   wideScreen ? 35 : 15,
            height:  wideScreen ? 35 : 15,
            left:    halfEggsPositions[0][ind],
            top:     halfEggsPositions[1][ind],
           // zIndex:  drag ? ind + 10 : 1,
            zIndex:  drag ? ((ind + 1) % 2) + 100 : (ind + 1) % 2,
            opacity: opacity,
            cursor:  opacity === 1 && !disable ? 'pointer' : 'default'
         }}
      />     
  );
}



export default DragableEgg;








